import { render, staticRenderFns } from "./MetadataField.vue?vue&type=template&id=464fc90c&scoped=true&"
import script from "./MetadataField.vue?vue&type=script&lang=js&"
export * from "./MetadataField.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./MetadataField.vue?vue&type=style&index=0&id=464fc90c&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "464fc90c",
  "6b9cf608"
  
)

export default component.exports